"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.S3UploadResponse = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.S3UploadResponse = typebox_1.Type.Object({
    /**
     * URL of the uploaded object.
     */
    Location: typebox_1.Type.String(),
    /**
     * ETag of the uploaded object.
     */
    ETag: typebox_1.Type.String(),
    /**
     * Bucket to which the object was uploaded.
     */
    Bucket: typebox_1.Type.String(),
    /**
     * Key to which the object was uploaded.
     */
    Key: typebox_1.Type.String(),
    /**
     * SHA256 checksum of the uploaded object. Only available for files created after 1.40.0 release!
     */
    ChecksumSHA256: typebox_1.Type.Optional(typebox_1.Type.String()),
});
//# sourceMappingURL=s3-upload-response.js.map